export default "__VITE_ASSET__CDL2chqD__"